let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hAY2w")).then(() => parcelRequire('6rUpt'));